import {GetterTree} from "vuex";
import {IAgencyManagementState} from "./am-state.store";
import {IRootState} from "../root-state.store";

export const getters: GetterTree<IAgencyManagementState, IRootState> = {
  characterProblems: (state: IAgencyManagementState) => {
    return state.characterProblems
  },
  amCrudActionStatus: (state: IAgencyManagementState) => state.crudActionStatus,
  characterProblemToEdit: (state: IAgencyManagementState) => state.characterProblemToEdit,
  characterProblem: (state: IAgencyManagementState) => state.characterProblem,
  attributeToEdit: (state: IAgencyManagementState) => state.attributeToEdit,
  attribute: (state: IAgencyManagementState) => state.attribute,
  attributeTypes: (state: IAgencyManagementState) => state.attributeTypes,
  attachmentTypes: (state: IAgencyManagementState) => state.attachmentTypes,
  attachmentType: (state: IAgencyManagementState) => state.attachmentType,
  attachmentTypeToEdit: (state: IAgencyManagementState) => state.attachmentTypeToEdit
}



// WEBPACK FOOTER //
// ./src/store/agency-management/am-getters.store.ts